/*

	imagesize

	usage:

	the height is calculated to preserve the aspect ratio from a provided image or given value

	return:
	height
*/

const sizeFromImage = (src, cb) => {
    const img = new Image();
    const size = {};
    img.onload = function () {
		size.w = this.width;
		size.h = this.height;
		cb(this.height, this.width);
	};
    img.onerror = function () {
		console.warn(`aspectheight:onerror:can not use image: ${src}`);
		cb();
	};
    img.src = src;
    return size;
};

export default {
	onsize(src, cb) {
		return sizeFromImage(src, cb);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/imagesize.js